<template>
    <div>
        <div v-if="!loading" class="home-pag">
          <section class="event team-sec team-grid speaker set-relative py-5" id="speaker">
            <div class="container" style="padding:35px;margin:auto;border: 1px solid black;page-break-after: always;">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2 text-center" style="widthx:35%;">
                      <p align="center" style="font-size: 18px;margin-bottom: 2px;font-family:'Times New Roman', Times, serif;">&nbsp;</p>
                      <img alt="" style="width:75px;margin-bottomx:5px" class="img-fluid" src="../../theme-assets/images/logo/cu_logo_black.png">
                    </div>
                    <div class="col-md-8 text-center" style="widthx:30%;">
                      &nbsp;
                    </div>
                    <div class="col-md-2 text-center" style="widthx:35%;">
                        <p align="center" style="color: black;font-size: 18px;margin-bottom: 2px;font-family:'Times New Roman', Times, serif;">&nbsp;</p>
                        <div class="qrcode" align="center" style="floatx:right;" ref="qrCodeUrl" id="qrCodeUrl"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12" style="margin-top:-30px">
                    <h4 style="text-transform: unset;color:black;font-family: kalpurush;font-weight:bold;font-size:30px" align="center">চট্টগ্রাম বিশ্ববিদ্যালয়</h4>
                    <p style="text-align:center;font-size: large;font-family: kalpurush;color:black;padding:10px">১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষ: ২০২৫-২০২৬</p>
                </div>
                <div class="col-md-12" style="margin-bottom: 20px;">
                    <p style="text-align:center;font-size: 27px;font-weight:bold;font-family: kalpurush;color:black;padding:10px;">Admission Test Result</p>
                    <p style="text-align:center;margin-bottom:10px" class="text-black">
                      <span class="px-3 py-1" style="border: 1px solid black;border-radius: 10px;">
                        Unit: <b>{{this.unit}}</b>&nbsp;Quota: <b>{{this.quota}}</b>
                      </span>
                    </p>
                </div>
                <div class="col-md-6" style="margin-bottom:30px">
                    <p style="font-size: 20px;color:black;font-family:'Times New Roman', Times, serif">Admission Roll: 
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(0)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(1)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(2)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(3)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(4)}}</span>
                      <span style="border: 2px solid black;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(5)}}</span>
                    </p>
                </div>
                <div class="col-md-6" style="margin-bottom:30px">
                    <p style="font-size: 20px;color:black;text-align:right;font-family:'Times New Roman', Times, serif">Application ID:
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(0)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(1)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(2)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(3)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(4)}}</span>
                      <span style="border: 2px solid black;padding: 2px 7px 2px 7px;">{{application_id.charAt(5)}}</span>
                    </p>
                </div>             
                <div class="col-md-12">
                  
                  <div class="card">
                    <div class="card-header bg-dark text-white" style="font-weight:bold">Applicant's Info</div>
                    <div class="card-bodyx">
                      <table class="table" style="font-weight: bold;margin:auto">
                        <tr>
                          <td class="count-desc" style="width:28%">Name</td>
                          <!--td class="count-desc">:</td-->
                          <th class="count-desc" style="width:72%">{{applicant.name}}</th>
                        </tr>
                        <tr>
                          <td class="count-desc">Father's Name</td>
                          <!--td class="count-desc">:</td-->
                          <th class="count-desc">{{applicant.fname}}</th>
                        </tr>
                        <tr>
                          <td class="count-desc">Mother's Name</td>
                          <!--td class="count-desc">:</td-->
                          <th class="count-desc">{{applicant.mname}}</th>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="card mt-3x mb-5x">
                    <div class="card-header bg-dark text-white" style="font-weight:bold">Marks obtained</div>
                    <div class="card-bodyx">
                      <table class="table table-bordered" style="font-weight: boldx;margin:auto">
                        <tr class="table-success">
                          <th class="count-desc" style="width:28%">Subject</th>
                          <th class="count-desc text-center" style="width:18%">Number</th>
                          <th class="count-desc text-center" style="width:18%">Correct Answer</th>
                          <th class="count-desc text-center" style="width:18%">Deduction</th>
                          <th class="count-desc text-center" style="width:18%">Obtained Marks</th>
                        </tr>
                        <tr v-for="mark in examMarks">
                          <td class="count-desc">{{mark.subject}}</td>
                          <td class="count-desc text-center">{{mark.max}}</td>
                          <td class="count-desc text-center">{{mark.correct}}</td>
                          <td class="count-desc text-center">{{mark.deduct}}</td>
                          <td class="count-desc text-center">{{mark.total}}</td>                                      
                        </tr>
                        <tr>
                          <th class="count-desc">Total</th>
                          <th class="count-desc text-center">100</th>
                          <th class="count-desc text-center">{{examResult.correct}}</th>
                          <th class="count-desc text-center">{{examResult.deduct}}</th>
                          <th class="count-desc text-center">{{examResult.exam_score}}</th>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="card mt-3x">
                    <div class="card-header bg-dark text-white" style="font-weight:bold">Marks obtained on HSC/Equivalent and SSC/Equivalent GPA</div>
                    <div class="card-bodyx">
                      <table class="table table-bordered">
                        <tr class="table-info">
                          <th class="count-desc" style="width: 46%" colspan="2">Exam Name</th>
                          <th class="count-desc text-center" style="width: 18%">GPA</th>
                          <th class="count-desc text-center" style="width: 18%">&nbsp;</th>
                          <th class="count-desc text-center" style="width: 18%">Marks</th>
                        </tr>
                        <tr>
                          <td class="count-desc" style="width: 46%" colspan="2">HSC/Equivalent</td>
                          <td class="count-desc text-center">{{this.examResult.hsc_gpa}}</td>
                          <td class="count-desc text-center">&nbsp;</td>
                          <td class="count-desc text-center">{{this.examResult.hsc_per}}</td>
                        </tr>
                        <tr>
                          <td class="count-desc" style="width: 46%" colspan="2">SSC/Equivalent </td>
                          <td class="count-desc text-center">{{this.examResult.ssc_gpa}}</td>
                          <td class="count-desc text-center">&nbsp;</td>
                          <td class="count-desc text-center">{{this.examResult.ssc_per}}</td>
                        </tr>
                        <tr>
                          <td class="count-desc" style="width: 82%" colspan="4">Deduction (Irregular)</td>
                          <td class="count-desc text-center" style="width: 18%">{{this.examResult.ssc_hsc_deduct}}</td>
                        </tr>
                        <tr>
                          <th class="count-desc" style="width: 82%" colspan="4">Total Score</th>
                          <th class="count-desc text-center" style="width: 18%">{{examResult.total}}</th>
                        </tr>
                        <tr>
                          <th class="count-desc" style="width: 82%"  colspan="4">Status</th>
                          <th class="count-desc text-center" style="width: 18%">{{examResult.status}}</th>
                          <!--th class="count-desc text-center" style="width: 18%">{{examResult.merit==0 ? "Fail":"Pass"}}</th-->
                        </tr>
                        <tr>
                          <th class="count-desc" style="width: 82%" colspan="4">Merit Position</th>
                          <th class="count-desc text-center" style="width: 18%">{{examResult.merit}}</th>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>           
              </div>
              <div class="row pt-0 mt-5">
                <div class="col-md-6 mb-0 mt-auto" style="vertical-align: bottom;">
                  <span style="font-style:italic;">Powered by <b>ICT Cell, University of Chittagong</b></span>
                </div>
                <div class="col-md-6" style="margin-top:10px;text-align:right;">
                  <!--img alt="" style="width:120px;margin-bottom:5px;margin-right:5px" class="img-fluid" :src="co_ordinator_signature">
                  <p style="text-align:right;line-height:1.2;color:black;padding-top:10px;font-family: kalpurush;font-size:15px">
                    {{unit_co_ordinator}}
                    <br> কো-অর্ডিনেটর,  
                    <span style="font-family:'Times New Roman', Times, serif">{{$route.params.unit}}</span> ইউনিট ভর্তি কমিটি 
                  </p-->
                </div>
              </div>
            </div>
          </section>         
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { GET_EXAM_RESULT, GET_DOCS } from '../../const/api'
import { GET } from '../../utils/Request'
import QRCode from 'qrcodejs2'
export default {
  name: 'ExamResult',
  components: { Loader, Banner },
  data() {
    return {
        loading: false,
        Schedule:'',
        firstTimeLoad: true,
        qrText:'',
        applicant:{},
        application:{},
        examResult:{},
        examMarks:{},
        unit_co_ordinator:'',
        co_ordinator_signature:'',
        message:'',
        exam_roll:'      ',
        application_id:'      '        
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getDocs();
  },
  mounted() { 
  },
  methods: {
    
    async getDocs() {
      
      var data = await GET(GET_EXAM_RESULT + this.$route.params.unit + '/' + this.$route.params.quota);
      
      /*console.log('test', data.data);*/

      var tt = '' + data.data.application.exam_roll;
        
      if(data.data.status=='success'){  
        this.applicant = data.data.applicant;
        this.application = data.data.application;
        this.examResult = data.data.result;
        this.examMarks = data.data.marks;
        
        this.unit = this.examResult.unit;
        this.quota = this.examResult.quota;

        this.exam_roll = this.application.exam_roll.toString();
        this.application_id = this.application.application_id.toString(); 
        
        this.unit_co_ordinator = data.data.unit_co_ordinator;
        this.co_ordinator_signature = data.data.co_ordinator_signature;

        this.message = '';
        
        /*this.qrText = 'Unit:'+this.$route.params.unit
          + ', Quota:'+ (this.$route.params.quota?this.$route.params.quota:'GENERAL')
          + ', Name:'+ this.applicant.name  
          + ', Roll:'+ this.application.exam_roll
          + ', AppID:'+ this.application.application_id
          + ', Medium:' + this.applicant.medium
          + ', Exam Score:' + this.examResult.exam_score
          + ', Total Score:' + this.examResult.total 
          + ', Status:' + this.examResult.sstatus)
          + ', Merit:' + (this.examResult.merit==0?'X':this.examResult.merit);*/

        /*this.qrText = 'http://dev.front.cu.ac.bd/check-exam-result/' + this.examResult.hash_key;*/
        this.qrText = `${process.env.VUE_APP_FRONTEND_URL}check-exam-result/${this.examResult.hash_key}`;
        /*this.qrText = 'http://localhost:8080/check-exam-result/' + this.examResult.hash_key;*/
        /*console.log('hash key: ', this.application.hash_key);*/
      }
      else{
        this.unit = '';
        this.quota = '';
        this.exam_roll = '      ';
        this.application_id = '      ';
        this.message = data.data.message;
        this.$iziToast.error({
            message: data.data.message
        });
        /*this.goForUrl('/');*/
      }
      this.timeoutForLoading();
    },
    
    goForUrl(url) {
      this.$router.replace(url)
    },
    
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false;
              this.getQR();
              window.print();
            }.bind(this),
            3000
          )
        })
      }
      this.firstTimeLoad = false
    },
    getQR(){
       let canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly
        canvasDiv.id = 'canvas'
        document.getElementById('qrCodeUrl').append(canvasDiv);
        let qrcode = new QRCode('canvas', { //qrcode generates QR code
          text: this.qrText,
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
        let canvas = document.getElementById('canvas').querySelector('canvas') //Get the canvas element
        var dataURL = canvas.toDataURL(); 
        canvas = null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  /* The image used */
  background-image: url("../../theme-assets/images/logo/cu_bg_logo.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:182.5vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.text-normal {
  font-weight: normal;
}

.text-bold {
  font-weight: bold;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}
.table td, .table th {
    padding: .5rem;
    vertical-align: top;
    border: 1px solid black;
    text-color: black;
}

.table td {
    font-weight: normal;
}

.table th {
    font-weight: bold;
}

</style>
